import { useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useRef } from "react";

const DrawingManagerCircleEditor = ({ onCreate }) => {
  const map = useMap();
  const mapLibCore = useMapsLibrary("core");
  const mapLibMaps = useMapsLibrary("maps");
  const mapLibMarker = useMapsLibrary("marker");
  const mapLibGeometry = useMapsLibrary("geometry");
  const circleRef = useRef(null);
  const isDrawing = useRef(false);
  // const center = useRef(null);
  // const centerMarkerRef = useRef(null);
  // const radiusMarkerRef = useRef(null);

  useEffect(() => {
    if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
      return;

    let mouseDownListener, mouseMoveListener, mouseUpListener;

    mouseDownListener = map.addListener("mousedown", (e) => {
      isDrawing.current = true;

      map.setOptions({ draggable: false, draggableCursor: "crosshair" });

      if (circleRef.current) circleRef.current.setMap(null);
      circleRef.current = new mapLibMaps.Circle({
        map,
        center: e.latLng,
        radius: 0,
        strokeColor: "#1976D2",
        fillColor: "#1976D2",
        fillOpacity: 0.2,
        strokeWeight: 2,
        clickable: false,
        editable: true,
        draggable: false,
        type: "circle",
      });
      // const div = document.createElement("div");
      // div.style.width = "12px";
      // div.style.height = "12px";
      // div.style.background = "#1976D2";
      // div.style.borderRadius = "50%";
      // div.style.border = "2px solid white";
      // // div.style.position = "absolute";
      // div.style.translate = "0px 5px";

      // centerMarkerRef.current = new mapLibMarker.AdvancedMarkerElement({
      //   map,
      //   position: e.latLng,
      //   content: div,
      //   gmpDraggable: true,
      // });
      // centerMarkerRef.current.addListener("drag", (ev) => {
      //   center.current = ev.latLng;
      //   circleRef.current.setCenter(ev.latLng);
      // });

      // // disable map drag while drawing
      // map.setOptions({ draggable: false });
    });

    mouseMoveListener = map.addListener("mousemove", (e) => {
      if (!isDrawing.current || !circleRef.current) return;
      const r = mapLibGeometry.spherical.computeDistanceBetween(
        circleRef.current.getCenter(),
        e.latLng
      );
      circleRef.current.setRadius(r);
    });

    mouseUpListener = map.addListener("mouseup", () => {
      if (isDrawing.current) {
        isDrawing.current = false;
        map.setOptions({ draggable: true });
        if (onCreate) {
          onCreate(circleRef.current);
          circleRef.current.setDraggable(true);
          // circleRef.current.setClickable(true);
          circleRef.current = undefined;
        }
      }
    });

    return () => {
      try {
        mapLibCore.event.removeListener(mouseDownListener);
        mapLibCore.event.removeListener(mouseMoveListener);
        mapLibCore.event.removeListener(mouseUpListener);
        // if (circleRef.current) circleRef.current.setMap(null);
        // if (radiusMarkerRef.current) radiusMarkerRef.current.map = null;
      } catch (error) {}
    };
  }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

  return null;
};

// const DrawingManagerCircleEditorFirst = () => {
//   const map = useMap();
//   const mapLibCore = useMapsLibrary("core");
//   const mapLibMaps = useMapsLibrary("maps");
//   const mapLibMarker = useMapsLibrary("marker");
//   const mapLibGeometry = useMapsLibrary("geometry");
//   const circleRef = useRef(null);
//   const isDrawing = useRef(false);
//   const center = useRef(null);
//   const centerMarkerRef = useRef(null);
//   const radiusMarkerRef = useRef(null);

//   function pointOnCircle(center, radius, bearing) {
//     return mapLibGeometry.spherical.computeOffset(center, radius, bearing);
//   }

//   function createCircleWithHandles(map, center, radius) {
//     const circle = new mapLibMaps.Circle({
//       map,
//       center,
//       radius,
//       editable: true,
//       draggable: true,
//       clickable: false,
//       strokeColor: "#4285F4",
//       strokeOpacity: 0.8,
//       strokeWeight: 2,
//       fillColor: "#4285F4",
//       fillOpacity: 0.2,
//     });

//     // const bearings = [0, 90, 180, 270]; // N, E, S, W
//     const bearings = []; // N, E, S, W
//     const handles = bearings.map((bearing) => {
//       const position = pointOnCircle(center, radius, bearing);
//       const div = document.createElement("div");
//       div.style.width = "12px";
//       div.style.height = "12px";
//       div.style.background = "#1976D2";
//       div.style.borderRadius = "50%";
//       div.style.border = "2px solid white";
//       div.style.translate = "0px 5px";
//       const marker = new mapLibMarker.AdvancedMarkerElement({
//         map,
//         position,
//         content: div,
//         gmpDraggable: true,
//       });
//       return { bearing, marker };
//     });

//     // Handle dragging one of the handles
//     handles.forEach(({ marker }) => {
//       marker.addListener("drag", () => {
//         const center = circle.getCenter();
//         const pos = marker.position;
//         const newRadius = mapLibGeometry.spherical.computeDistanceBetween(
//           center,
//           pos
//         );
//         circle.setRadius(newRadius);
//         updateHandles(circle, handles);
//       });
//     });

//     // Update handles when the circle moves
//     circle.addListener("center_changed", () => updateHandles(circle, handles));
//     circle.addListener("radius_changed", () => updateHandles(circle, handles));

//     function updateHandles(circle, handles) {
//       const center = circle.getCenter();
//       const radius = circle.getRadius();
//       handles.forEach(({ bearing, marker }) => {
//         marker.position = pointOnCircle(center, radius, bearing);
//       });
//     }

//     return { circle, handles };
//   }

//   useEffect(() => {
//     if (!map || !mapLibCore || !mapLibMaps || !mapLibMarker || !mapLibGeometry)
//       return;

//     let mouseDownListener, mouseMoveListener, mouseUpListener;

//     mouseDownListener = map.addListener("mousedown", (e) => {
//       console.log("mousedown");
//       isDrawing.current = true;
//       center.current = e.latLng;

//       const { circle } = createCircleWithHandles(map, center.current, 0);
//       circleRef.current = circle;

//       map.setOptions({ draggable: false });

//       // if (circleRef.current) circleRef.current.setMap(null);
//       // circleRef.current = new mapLibMaps.Circle({
//       //   map,
//       //   center: center.current,
//       //   radius: 0,
//       //   strokeColor: "#1976D2",
//       //   fillColor: "#1976D2",
//       //   fillOpacity: 0.2,
//       //   strokeWeight: 2,
//       //   clickable: false,
//       // });
//       // const div = document.createElement("div");
//       // div.style.width = "12px";
//       // div.style.height = "12px";
//       // div.style.background = "#1976D2";
//       // div.style.borderRadius = "50%";
//       // div.style.border = "2px solid white";
//       // // div.style.position = "absolute";
//       // div.style.translate = "0px 5px";
//       // centerMarkerRef.current = new mapLibMarker.AdvancedMarkerElement({
//       //   map,
//       //   position: e.latLng,
//       //   content: div,
//       //   gmpDraggable: true,
//       // });
//       // centerMarkerRef.current.addListener("drag", (ev) => {
//       //   center.current = ev.latLng;
//       //   circleRef.current.setCenter(ev.latLng);
//       // });

//       // // disable map drag while drawing
//       // map.setOptions({ draggable: false });
//     });

//     mouseMoveListener = map.addListener("mousemove", (e) => {
//       console.log("mousemove 1");
//       if (!isDrawing.current || !circleRef.current) return;
//       console.log("mousemove 2");

//       const r = mapLibGeometry.spherical.computeDistanceBetween(
//         center.current,
//         e.latLng
//       );
//       circleRef.current.setRadius(r);

//       // Show radius handle using AdvancedMarkerElement
//       if (!radiusMarkerRef.current) {
//         const div = document.createElement("div");
//         div.style.width = "12px";
//         div.style.height = "12px";
//         div.style.background = "#1976D2";
//         div.style.borderRadius = "50%";
//         div.style.border = "2px solid white";
//         div.style.translate = "0px 5px";
//         radiusMarkerRef.current = new mapLibMarker.AdvancedMarkerElement({
//           map,
//           position: e.latLng,
//           content: div,
//           gmpDraggable: true,
//         });

//         radiusMarkerRef.current.addListener("drag", (ev) => {
//           const newRadius = mapLibGeometry.spherical.computeDistanceBetween(
//             center.current,
//             ev.latLng
//           );
//           circleRef.current.setRadius(newRadius);
//         });
//       } else {
//         radiusMarkerRef.current.position = new mapLibCore.LatLng({
//           lat: center.current.lat() - circleRef.current.getRadius(),
//           lng: center.current.lng(),
//         });
//       }
//     });

//     mouseUpListener = map.addListener("mouseup", () => {
//       console.log("mouseup");
//       if (isDrawing.current) {
//         isDrawing.current = false;
//         map.setOptions({ draggable: true });
//       }
//     });

//     return () => {
//       console.log("cleanup");

//       try {
//         mapLibCore.event.removeListener(mouseDownListener);
//         mapLibCore.event.removeListener(mouseMoveListener);
//         mapLibCore.event.removeListener(mouseUpListener);
//         if (circleRef.current) circleRef.current.setMap(null);
//         if (radiusMarkerRef.current) radiusMarkerRef.current.map = null;
//       } catch (error) {}
//     };
//   }, [mapLibCore, mapLibMarker, mapLibMaps, mapLibGeometry]);

//   return null;
// };

export default DrawingManagerCircleEditor;
